// historicalGradesBarChartBuilder.js
import { v4 as uuidv4 } from 'uuid';
import getGPAColor from './getGPAColor.js';
import { getGPA } from './getGPA.js';
import { get } from 'jquery';
export function historicalGradesBarChartBuilder(label, enrollmentObject) {
  const barColors = [];
  const enrollmentOrdered = Object.keys(enrollmentObject).sort().reduce((obj, key) => {
    obj[key] = enrollmentObject[key];
    return obj;
  }, {});

  Object.keys(enrollmentOrdered).forEach((key) => {
    if (key === 'A') barColors.push(getGPAColor(4.0));
    else if (key === 'B') barColors.push(getGPAColor(3.0));
    else if (key === 'C') barColors.push(getGPAColor(2.0));
    else if (key === 'D') barColors.push(getGPAColor(1.0));
    else if (key === 'F') barColors.push(getGPAColor(0.0));
    else barColors.push('rgba(0, 0, 0, 1)');
  });

  return {
    labels: Object.keys(enrollmentOrdered),
     options: {
      plugins: {
        datalabels: {
          color: 'white',
          font: { weight: 'bold' },
        },
      },
    },
    datasets: [{
      id: uuidv4(),
      label,
      data: Object.values(enrollmentOrdered),
      backgroundColor: barColors,
      color: 'black',
    }],
  };
}
